import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    container:{
        backgroundColor: '#F4F4F4',
        width: '100%',
        height: '400px',
        color: '#666666',
        overflow: 'auto'
    },
    hLine:{
        borderBottomStyle: 'solid',
        borderBottomWidth: '1px',
        borderBottomColor: '#4C4C4C',
        opacity: '0.4'
    }
}));

export default useStyles;
